import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Building2, FileText, ShieldCheck } from 'lucide-react';
import MemberCenterLayout from '../components/common/MemberCenterLayout';
import AboutUs from './AboutUs';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';

const ABOUT_TABS = [
  { key: 'about', label: '關於我們', icon: Building2, Content: AboutUs },
  { key: 'terms', label: '服務條款', icon: FileText, Content: TermsOfService },
  { key: 'privacy', label: '隱私政策', icon: ShieldCheck, Content: PrivacyPolicy }
];

export default function AboutJoinU() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const activeTab = ABOUT_TABS.some(tab => tab.key === requestedTab) ? requestedTab : 'about';
  const current = ABOUT_TABS.find(tab => tab.key === activeTab);
  const ActiveContent = current.Content;

  useEffect(() => {
    if (requestedTab !== activeTab) {
      setSearchParams({ tab: activeTab }, { replace: true });
    }
  }, [activeTab, requestedTab, setSearchParams]);

  const selectTab = key => {
    setSearchParams({ tab: key }, { replace: true });
  };

  const handleTabKeyDown = (event, index) => {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (!keys.includes(event.key)) return;
    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + ABOUT_TABS.length) % ABOUT_TABS.length;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % ABOUT_TABS.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = ABOUT_TABS.length - 1;
    const nextTab = ABOUT_TABS[nextIndex];
    selectTab(nextTab.key);
    requestAnimationFrame(() => document.getElementById(`about-tab-${nextTab.key}`)?.focus());
  };

  return (
    <MemberCenterLayout
      title="關於 JoinU"
      subtitle="認識我們，並查看服務與隱私相關說明"
      activeKey="about-joinu"
    >
      <div className="member-center-tabs" role="tablist" aria-label="關於 JoinU 分類">
        {ABOUT_TABS.map((tab, index) => {
          const Icon = tab.icon;
          const isActive = tab.key === activeTab;
          return (
            <button
              key={tab.key}
              id={`about-tab-${tab.key}`}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={`about-panel-${tab.key}`}
              tabIndex={isActive ? 0 : -1}
              className={`member-center-tab${isActive ? ' member-center-tab--active' : ''}`}
              onClick={() => selectTab(tab.key)}
              onKeyDown={event => handleTabKeyDown(event, index)}
            >
              <Icon size={16} aria-hidden="true" />
              {tab.label}
            </button>
          );
        })}
      </div>

      <section
        id={`about-panel-${activeTab}`}
        role="tabpanel"
        aria-labelledby={`about-tab-${activeTab}`}
      >
        <ActiveContent embedded />
      </section>
    </MemberCenterLayout>
  );
}
